export default __webpack_public_path__ + "static/SRF Carasweet 5S7705 - Fiche de spécifications et données techniques-a5f452258ed081d7bc0843cc36122de8.pdf";